"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _FormField = _interopRequireDefault(require("./FormField"));
var SelectField = function SelectField(_ref) {
  var id = _ref.id,
    children = _ref.children,
    errorMessage = _ref.errorMessage,
    hideErrorLabel = _ref.hideErrorLabel,
    hideLabel = _ref.hideLabel,
    labelId = _ref.labelId,
    required = _ref.required,
    styleContainer = _ref.styleContainer,
    styleInput = _ref.styleInput,
    styleInputError = _ref.styleInputError,
    styleWrapper = _ref.styleWrapper;
  return _react["default"].createElement(_reactFinalForm.Field, {
    id: id,
    name: id,
    component: _FormField["default"],
    element: "select",
    errorMessage: errorMessage,
    hideErrorLabel: hideErrorLabel,
    hideLabel: hideLabel,
    labelId: labelId,
    required: required,
    styleContainer: styleContainer,
    styleInput: styleInput,
    styleInputError: styleInputError,
    styleWrapper: styleWrapper,
    value: ""
  }, children);
};
SelectField.defaultProps = {
  styleContainer: {},
  styleInput: {},
  styleInputError: {},
  styleWrapper: {}
};
var _default = exports["default"] = SelectField;